import { List } from "linq.ts";
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["Sql"] = 1] = "Sql";
    DataSourceType[DataSourceType["ProcesoX"] = 2] = "ProcesoX";
    DataSourceType[DataSourceType["SharePoint"] = 3] = "SharePoint";
    DataSourceType[DataSourceType["Entity"] = 4] = "Entity";
    DataSourceType[DataSourceType["ProjectDataSource"] = 5] = "ProjectDataSource";
    DataSourceType[DataSourceType["FormServerExtension"] = 6] = "FormServerExtension";
})(DataSourceType || (DataSourceType = {}));
export const DataSourceTypeDataSource = new List([
    { key: DataSourceType.Entity, text: 'Entity' },
    { key: DataSourceType.FormServerExtension, text: 'FormServerExtension' },
    { key: DataSourceType.ProcesoX, text: 'ProcesoX' },
    { key: DataSourceType.ProjectDataSource, text: 'ProjectDataSource' },
    { key: DataSourceType.SharePoint, text: 'SharePoint' },
    { key: DataSourceType.Sql, text: 'Sql' }
]).OrderBy(o => o.text).ToArray();
